// extracted by mini-css-extract-plugin
export default {"input":"FormPasswordInput_input__CfKSa","label":"FormPasswordInput_label__z6YRb"};